import {inject, Injectable} from '@angular/core';
import {Actions, createEffect, ofType} from '@ngrx/effects';
import * as fromProFaxActions from '../actions/pro-fax.actions';
import {catchError, map, switchMap} from 'rxjs/operators';
import {of} from 'rxjs/internal/observable/of';
import {WebshopRestService} from '../../services/api/webshop-rest.service';
import {ProductsResponse} from '../../models/shop/products-response.model';

@Injectable()
export class ProFaxEffects {
    private actions$ = inject(Actions);
    private productRestService = inject(WebshopRestService);
    /**
     * In case of SearchInvoicesAction we're going to call the InvoicesService and then
     * we'll post a LoadInvoicesCompleteAction to the reducer or in case of failure
     * LoadInvoicesFailAction
     *
     * @type {Observable<any>}
     */
    loadProFax$ = createEffect(() =>
        this.actions$.pipe(
            ofType<fromProFaxActions.LoadProFaxAction>(
                fromProFaxActions.ProFaxActionTypes.LOAD_PROFAX
            ),
            map(action => action.payload),
            switchMap(productRequest =>
                this.productRestService.loadProFax().pipe(
                    switchMap(data => {
                        const prodResp = new ProductsResponse({ ...data.returnObject });
                        if (productRequest.page === 1) {
                            return [
                                new fromProFaxActions.LoadProFaxCompleteAction(prodResp),
                                new fromProFaxActions.GetBatchFromCacheAction()
                            ];
                        } else {
                            return [new fromProFaxActions.LoadProFaxCompleteAction(prodResp)];
                        }
                    }),
                    catchError(error => of(new fromProFaxActions.LoadProFaxFailAction(error)))
                )
            )
        )
    );

    searchProFax$ = createEffect(() =>
        this.actions$.pipe(
            ofType<fromProFaxActions.SearchShopAction>(
                fromProFaxActions.ProFaxActionTypes.SEARCH_PROFAX
            ),
            map(action => action.payload),
            switchMap(productRequest => [
                new fromProFaxActions.LoadProFaxAction(productRequest)
            ])
        )
    );
    
}